module.exports = __webpack_public_path__ + "img/200px-HK_Chater_House.b0863c11.jpg";